var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.isTextTruncated},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({ref:"textElement",staticClass:"truncate-text"},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.textoFormatado)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.textoFormatado))])])
}
var staticRenderFns = []

export { render, staticRenderFns }